import * as MutationTypes from './mutationTypes';

const selectedSelectedMenuForGrid = (state, menu) => {
  state.selectedMenuForGrid = menu;
};

const selectGridConfiguration = (state, gridConfiguration) => {
  state.gridConfiguration = gridConfiguration;
};

const selectCol = (state, col) => {
  state.col = col;
};

const selectRow = (state, row) => {
  state.row = row;
};

const selectGridItem = (state, gridItem) => {
  state.selectGridItem = gridItem;
};

const selectGridTemplateArea = (state, template) => {
  state.gridTemplateArea = template;
};

const updateMenuGridConfigurationSuccess = (state, updatedMenuGridConfiguration) => {
  state.gridConfiguration = updatedMenuGridConfiguration;
  state.updateMenuGridConfigurationSuccess = updatedMenuGridConfiguration;
};

const selectCache = (state, cache) => {
  state.cache = cache;
};

const selectPaddingGrid = (state, paddingGrid) => {
  state.paddingGrid = paddingGrid;
};

const selectImage = (state, image) => {
  state.image = image;
};

const updateSelectGridItemConfiguration = (state, gridItemConfigurationForm) => {
  state.selectGridItemConfiguration = state.selectGridItemConfiguration.overwrite(gridItemConfigurationForm);
};

const selectAspectRatio = (state, aspectRatio) => {
  state.aspectRatio = aspectRatio;
};

const selectBackgroundImageSizeBehaviour = (state, backgroundImageSizeBehaviour) => {
  state.backgroundImageSizeBehaviour = backgroundImageSizeBehaviour;
};

const selectMenuGridItemList = (state, menuGridItemList) => {
  state.menuGridItemList = menuGridItemList;
};

const selectClauseList = (state, clauseList) => {
  state.clausesList = clauseList;
};

const selectGridItemConfiguration = (state, gridItemConfiguration) => {
  state.selectGridItemConfiguration = gridItemConfiguration;
};

const gridItemToDelete = (state, selectedGridItemToDelete) => {
  state.gridItemToDelete = selectedGridItemToDelete;
};

const setOpenPortal = (state, openPortal) => {
  state.openPortal = openPortal;
};

export const mutations = {
  [MutationTypes.SELECT_MENU_FOR_GRID]: selectedSelectedMenuForGrid,
  [MutationTypes.GRID_CONFIGURATION]: selectGridConfiguration,
  [MutationTypes.SELECT_COL]: selectCol,
  [MutationTypes.SELECT_ROW]: selectRow,
  [MutationTypes.SELECT_GRID_ITEM]: selectGridItem,
  [MutationTypes.SELECT_GRID_TEMPLATE_AREA]: selectGridTemplateArea,
  [MutationTypes.UPDATE_MENU_GRID_CONFIGURATION_SUCCESS]: updateMenuGridConfigurationSuccess,
  [MutationTypes.SELECT_CACHE]: selectCache,
  [MutationTypes.SELECT_PADDING_GRID]: selectPaddingGrid,
  [MutationTypes.SELECT_IMAGE]: selectImage,
  [MutationTypes.UPDATE_MENU_GRID_ITEM_CONFIGURATION]: updateSelectGridItemConfiguration,
  [MutationTypes.SELECT_ASPECT_RATIO]: selectAspectRatio,
  [MutationTypes.SELECT_BACKGROUND_IMAGE_SIZE_BEHAVIOUR]: selectBackgroundImageSizeBehaviour,
  [MutationTypes.SELECT_MENU_GRID_ITEM_LIST]: selectMenuGridItemList,
  [MutationTypes.SELECT_CLAUSE_LIST]: selectClauseList,
  [MutationTypes.SELECT_MENU_GRID_ITEM_CONFIGURATION]: selectGridItemConfiguration,
  [MutationTypes.GRID_ITEM_TO_DELETE]: gridItemToDelete,
  [MutationTypes.SET_OPEN_PORTAL]: setOpenPortal,
};
